import { Button, CardinalLocation, Tooltip, TruncatedText } from "@hex-insights/core";
import {
	FormState,
	FormTooltipButton,
	FormTooltipButtonButtonProps,
	FormTooltipButtonTooltipProps,
} from "@hex-insights/forms";
import { UserSelectField } from "../../../Forms";
import * as UserGroupFilterFormValues from "../form-values";

const filterTooltipSideOrder: CardinalLocation[] = ["bottom", "top", "right", "left"];

type BaseFieldProps<K extends keyof UserGroupFilterFormValues.FilterFormValues> = {
	formState: FormState<Pick<UserGroupFilterFormValues.FilterFormValues, K>>;
};

export function MemberIDsInTooltipButton({ formState }: BaseFieldProps<"memberIDsIn">) {
	return (
		<FormTooltipButton formState={formState} sideOrder={filterTooltipSideOrder} autoFocus>
			{MemberIDsInTooltipButton.Tooltip}
			{MemberIDsInTooltipButton.Button}
		</FormTooltipButton>
	);
}

MemberIDsInTooltipButton.Tooltip = function ({
	formState,
}: FormTooltipButtonTooltipProps<Pick<UserGroupFilterFormValues.FilterFormValues, "memberIDsIn">>) {
	return (
		<Tooltip isInteractable>
			<Tooltip.Body>
				<MemberIDsIn formState={formState} />
			</Tooltip.Body>
		</Tooltip>
	);
};

MemberIDsInTooltipButton.Button = function ({
	formState,
	onClick,
}: FormTooltipButtonButtonProps<Pick<UserGroupFilterFormValues.FilterFormValues, "memberIDsIn">>) {
	const memberIDsIn = formState.formValues.memberIDsIn;

	return (
		<Button variant={memberIDsIn.length > 0 ? "primary" : "tertiary"} onClick={onClick}>
			<TruncatedText style={{ maxWidth: "10rem" }}>
				{memberIDsIn.length > 0 ? `${formState.formFormatFunctions.memberIDsIn(memberIDsIn)}` : "Members"}
			</TruncatedText>
		</Button>
	);
};

export function MemberIDsIn({ formState }: BaseFieldProps<"memberIDsIn">) {
	return <UserSelectField.MultiSelect formState={formState} name="memberIDsIn" label="Members" noOptional />;
}
